import React from 'react';
import { Button, ButtonsContainer, PageWrapper } from 'virtues-bootstrap';
import { Link } from 'react-router-dom';

import OrganizationsTable from 'containers/Organizations/Table';

import s from './styles.module.scss';

const Organizations = () => {
  return (
    <PageWrapper>
      <ButtonsContainer className={s.buttonsContainer} noSpaceTop>
        <h1 className={s.title}>Manage sites</h1>
        <div>
          <Button component={Link} to="/add-practitioner" variant="secondary">
            Add practitioner
          </Button>
          <Button component={Link} to="/add-site" variant="secondary">
            Add site
          </Button>
        </div>
      </ButtonsContainer>

      <OrganizationsTable />
    </PageWrapper>
  );
};

export default Organizations;
